<template>
    <div class="table">
        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;">
                    <div style="width:150px;">
                        <el-radio-group v-model="form.atdType" @change="atdTypeChange()">
                            <el-radio-button label="1">行政班</el-radio-button>
                            <el-radio-button label="2">导师班</el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;" v-if="form.atdType == 1">
                    <div style="width:160px;">
                        <el-input v-model="form.atdClassName" placeholder="行政班"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;" v-if="form.atdType == 2">
                    <div style="width:160px;">
                        <el-input v-model="form.atdMentorName" placeholder="导师班"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;">
                    <div style="width:140px;">
                        <el-input v-model="form.teacherName" placeholder="老师姓名"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;">
                    <el-date-picker
                        style="width:140px;"
                        v-model="form.startDate"
                        type="date"
                        placeholder="开始日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;">
                    <el-date-picker
                        style="width:140px;"
                        v-model="form.endDate"
                        type="date"
                        placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;float:right;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                    <!-- <el-button type="primary" icon="search" @click="exportExcel">导出Excel</el-button> -->
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="450"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="atdClassName" label="行政班" width="100" v-if="form.atdType == 1"></el-table-column>
                <el-table-column prop="atdMentorName" label="导师班" width="100" v-if="form.atdType == 2"></el-table-column>
                <el-table-column prop="" label="考勤名称">
                    <template slot-scope="scope">
                        <span v-if="scope.row.className && scope.row.title1">{{scope.row.title1}}（{{scope.row.className}}）</span>
                        <span v-else-if="scope.row.title1">{{scope.row.title1}}</span>
                        <span v-else>{{scope.row.className}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="attRate" label="出勤率" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.attRate != null ? scope.row.attRate + '%' : '0%' }}
                    </template>
                </el-table-column>
                <el-table-column prop="absCount" label="缺勤人数" width="100"></el-table-column>
                <el-table-column prop="lateCount" label="迟到人数" width="100"></el-table-column>
                <el-table-column prop="lvCount" label="请假人数" width="100"></el-table-column>
                <el-table-column prop="teacherName" label="老师姓名" width="100"></el-table-column>
                <el-table-column prop="workDate" label="日期时间" width="160"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="showDetail(scope.row)" style="color:#387EE8;">查看明细</el-button>
                    </template>
                </el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>

        <!-- 查看明细弹框 -->
        <el-dialog title="考勤明细" :visible.sync="detailVisible" :close-on-click-modal="false" width="900px">
            <div style="margin-bottom:10px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="detailForm.name" placeholder="学生姓名"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px; margin-left:5px;">
                    <div style="width:160px;">
                        <el-select v-model="detailForm.status" placeholder="考勤状态" clearable>
                            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="detailCommon.page = 1;getDetailData()">查询</el-button>
                </div>
            </div>
            <el-table :data="detailData" height="390" style="width: 100%;margin-bottom: 20px;" border v-loading="detailLoading">
                <el-table-column type="index" label="序号" width="55" :index="detailIndexMethod"></el-table-column>
                <el-table-column prop="name" label="学生姓名" width="100"></el-table-column>
                <el-table-column prop="atdClassName" label="行政班" width="100" v-if="form.atdType == 1"></el-table-column>
                <el-table-column prop="atdMentorName" label="导师班" width="100" v-if="form.atdType == 2"></el-table-column>
                <el-table-column prop="" label="考勤名称">
                    <template slot-scope="scope">
                        <span v-if="scope.row.className && scope.row.title1">{{scope.row.title1}}（{{scope.row.className}}）</span>
                        <span v-else-if="scope.row.title1">{{scope.row.title1}}</span>
                        <span v-else>{{scope.row.className}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="workDate" label="考勤时间" width="160"></el-table-column>
                <el-table-column prop="title2" label="考勤状态" width="100"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="detailHandleSizeChange"
                    @current-change="detailHandleCurrentChange"
                    :current-page="detailCommon.page"
                    :page-size="detailCommon.pageSize"
                    :page-sizes="detailCommon.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="detailCommon.total">
                </el-pagination>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http';

    export default {
        name:"Student",
        data(){
            return{
                loading:false,
                loadingText:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    deptId:"",
                    atdType:1,
                    atdClassName:"",
                    atdMentorName:"",
                    teacherName:"",
                    startDate:"",
                    endDate:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[],
                detailVisible:false,
                detailLoading:false,
                detailRow:null,
                detailForm:{
                    name:"",
                    status:""
                },
                statusOptions:[
                    { value: 1, label: '出勤' },
                    { value: 2, label: '缺勤' },
                    { value: 3, label: '请假' },
                    { value: 4, label: '迟到' }
                ],
                detailCommon:{
                    total:0,
                    pageSize:30,
                    page:1,
                    isPage:1,
                    allSizes:[30,50,100]
                },
                detailData:[]
            }
        },
        created:function () {
            this.getDeptData();
        },
        components: {
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中...";
                let url  = this.listStudentAttendanceCatalogueUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    atdType:this.form.atdType,
                    atdClassName:this.form.atdClassName,
                    atdMentorName:this.form.atdMentorName,
                    teacherName:this.form.teacherName,
                    startDate:this.form.startDate==null?"":this.form.startDate,
                    endDate:this.form.endDate==null?"":this.form.endDate
                };       
                // console.log(JSON.stringify(data))
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
           },
           atdTypeChange(){
                this.form.atdClassName = "";
                this.form.atdMentorName = "";
                this.common.page = 1;
                this.getData();
           },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            exportExcel(){
                let msg="导出学生考勤数据只支持导出1W条，超出会导出失败，请确认当前页面总条数！";
                this.$commonFn.showConfirm2(msg,this.exportData);
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";
                let url=this.excelCountDownloadStudentUrl;
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('atdType', this.form.atdType);
                param.append('atdClassName', this.form.atdClassName);
                param.append('teacherName', this.form.teacherName);
                param.append('startDate', this.form.startDate==null?"":this.form.startDate);
                param.append('endDate', this.form.endDate==null?"":this.form.endDate);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '学生考勤统计.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error); 
                    this.loading=false;
                });
           },
           showDetail(row){
                this.detailRow = row;
                this.detailForm.name = "";
                this.detailForm.status = "";
                this.detailCommon.page = 1;
                this.detailCommon.total = 0;
                this.detailData = [];
                this.detailVisible = true;
                this.getDetailData();
           },
           getDetailData(){
                this.detailLoading=true;
                let url  = this.studentAttendanceDetailListUrl;
                let data = {
                    isPage:this.detailCommon.isPage,
                    page:this.detailCommon.page,
                    limit:this.detailCommon.pageSize,
                    attendanceCatalogueId:this.detailRow.id, 
                    name:this.detailForm.name,
                    status:this.detailForm.status
                };       
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.detailData = res.data.list;
                       this.detailCommon.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.detailLoading=false;
                },(err)=>{
                    this.detailLoading=false;
                });
           },
           detailIndexMethod(index) {
                return (this.detailCommon.page-1)*this.detailCommon.pageSize+(index+1);
           },
           detailHandleSizeChange(val) {
                this.detailCommon.pageSize = val;
                this.detailCommon.page = 1;
                this.getDetailData();
           },
           detailHandleCurrentChange(val) {
                this.detailCommon.page = val;
                this.getDetailData();
           },

        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/count/student/StudentCatalogue.vue